/*
  BACKGROUND FEATURE MODULES | věci na pozadí / "neviditelné vrstvy"

  Inicializace knihoven apod.
*/

// MINILAZYLOAD | Lazy loading obrázků
export const cncMiniLazyLoad = async () => {
  const lazyLoadedImages: NodeListOf<HTMLImageElement> = document.querySelectorAll('.lazyload');

  if (lazyLoadedImages && lazyLoadedImages.length) {
    const { CncMiniLazyLoad } = await import(
      /* webpackChunkName: 'default/chunk-lazyload-images' */
      '@features/miniLazyLoad'
    );

    CncMiniLazyLoad({ lazyLoadedImages });
  }
};

// GTMHIGHLIGHT (dříve GTM2BORDERS) | Vykreslení rámečků pro GTM
export const gtmHighlight = async () => {
  const metaConfigElement: HTMLTemplateElement | null =
    document.querySelector('[data-gtm-highlight]');

  if (metaConfigElement) {
    const { GTMHighlight } = await import(
      /* webpackChunkName: 'default/chunk-gtm-highlight' */
      '@features/gtm/gtmHighlight'
    );

    GTMHighlight();
  }
};
